import React from "react";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { useForm, Controller } from "react-hook-form";
import {
  Button,
  Grid,
  Typography,
  InputLabel,
  TextField,
} from "@material-ui/core";
import * as mutations from "graphql/mutations";
import * as query from "graphql/queries";
import { API, graphqlOperation } from "aws-amplify";
import * as Router from "@reach/router";
import { useDispatch } from "react-redux";
import common from "features/common/commonSlice";
import { useTranslation } from "react-i18next";
import Text from "components/atoms/inputs/Text";
import { pascalCase } from "change-case";
import { useSelector } from "react-redux";
import SaveIcon from "@material-ui/icons/Save";
import formatISO from "date-fns/formatISO";
import format from "date-fns/format";
import _ from "lodash";

const useStyles = makeStyles((theme: any) =>
  createStyles({
    root: {
      // display: 'flex',
      // flexWrap: 'wrap',
    },
    textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
  })
);

type FormParams = {
  name: string;
  as: any;
  onChange: any;
};

type Props = {
  formParams: FormParams[];
  dataType: string;
  hiddenCreateInputs?: {};
};

export default function Form(props: Props) {
  const { formParams, dataType, hiddenCreateInputs } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const loading = useSelector((state: any) => state.common.loading) as any;
  const { groups } = useSelector((state: any) => state.user) as any;

  console.log("Form:", formParams, dataType);
  // const history = useHistory();
  const form = useForm();

  // @see reduxを用いて入力内容の操作
  const show = useSelector((state: any) => state.user.selectedShow);
  const modifyInput = (input: any) => {
    formParams.forEach((val: any) => {
      if (val.input_name) {
        if (Array.isArray(val.input_name)) {
          const _tmp = input[val.name];
          delete input[val.name];
          val.input_name.forEach((_v, _i) => {
            input[_v] = _tmp[_i];
          });
        } else {
          input[val.input_name] = input[val.name];
          delete input[val.name];
        }
      }
    });
    if (input.startDateTime) {
      input.startDateTime = formatISO(new Date(input.startDateTime));
    }
    if (input.endDateTime) {
      input.endDateTime = formatISO(new Date(input.endDateTime));
    }
    if (hiddenCreateInputs) {
      Object.keys(hiddenCreateInputs).forEach((key: any) => {
        input[key] = hiddenCreateInputs[key];
      });
    }
    return input;
  };

  const onSubmit = (data: any) => {
    console.log("onSubmit:", data);
    dispatch(common.actions.fetchStart());

    _.each((data: any, key: string) => {
      if (Number.isFinite(+data[key])) {
        data[key] = Number(data[key]);
      }
    });
    async function _create() {
      try {
        if (show && !formParams.find((param) => param.name === "owner")) {
          data.owner = show.owner;
        }
        await API.graphql(
          // @ts-ignore
          graphqlOperation(mutations[`create${pAtion}`], {
            input: modifyInput(data),
          })
        );
        dispatch(common.actions.fetchSuccess());
        window.history.back();
      } catch (error) {
        console.error("error:", error);
        dispatch(common.actions.fetchFailure(error));
      }
    }

    async function _delete() {
      try {
        // @todo 数値型を他で行いたい
        await API.graphql(
          // @ts-ignore
          graphqlOperation(mutations[`delete${pAtion}`], {
            input: {
              id: data.id,
              expectedVersion: Number(data.expectedVersion),
            },
          })
        );
        dispatch(common.actions.fetchSuccess());
        window.history.back();
      } catch (error) {
        console.error("error:", error);
        dispatch(common.actions.fetchFailure(error));
      }
    }

    async function _update() {
      try {
        // @todo 数値型を他で行いたい
        data.expectedVersion = Number(data.expectedVersion);
        if (show && !formParams.find((param) => param.name === "owner")) {
          data.owner = show.owner;
        }
        await API.graphql(
          // @ts-ignore
          graphqlOperation(mutations[`update${pAtion}`], {
            input: modifyInput(data),
          })
        );
        dispatch(common.actions.fetchSuccess());
        window.history.back();
      } catch (error) {
        console.error("error:", error);
        dispatch(common.actions.fetchFailure(error));
      }
    }

    if (action === "new") {
      _create();
    } else if (action === "delete") {
      _delete();
    } else {
      _update();
    }
  };
  const params = Router.useParams();
  const location = Router.useLocation();
  let action = "edit";

  if (params.action === "new") {
    action = "new";
  }

  if (params.action === "delete") {
    action = "delete";
  }

  console.log(params, location);
  const pAtion = pascalCase(dataType);

  React.useEffect(() => {
    async function get() {
      dispatch(common.actions.fetchStart());
      try {
        const value = await API.graphql(
          // @ts-ignore
          graphqlOperation(query[`get${pAtion}`], { id: params.id })
        );
        //@ts-ignore
        const data = value.data[`get${pAtion}`] as any;
        form.setValue("id", data.id);
        form.setValue("expectedVersion", data.version);
        form.setValue("owner", data.owner);
        formParams.forEach((param) => {
          if (data[param.name]) {
            if (param.name === "startDateTime") {
              form.setValue(
                param.name,
                format(new Date(data[param.name]), "yyyy-MM-dd'T'HH:mm:ss")
              );
            } else if (param.name === "endDateTime") {
              form.setValue(
                param.name,
                format(new Date(data[param.name]), "yyyy-MM-dd'T'HH:mm:ss")
              );
            } else {
              form.setValue(param.name, data[param.name]);
            }
          }
        });

        dispatch(common.actions.fetchSuccess());
      } catch (error) {
        console.error("error:", error);
        dispatch(common.actions.fetchFailure(error));
      }
    }

    if (action === "new") {
      if (show) {
        form.setValue("showID", show.id);
        form.setValue("owner", show.owner);
      }
    } else {
      get();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <Typography variant="h6">{`${t(dataType)} ${t(
              action
            )}`}</Typography>
          </Grid>
          {action !== "new" && <Text name="id" form={form} value={params.id} />}
          {action !== "new" && (
            <input name="expectedVersion" type="hidden" ref={form.register} />
          )}
          {formParams.map((params) => (
            <Grid item xs={12}>
              <InputLabel>{t(params.name)}</InputLabel>
              <Controller {...params} control={form.control} />
            </Grid>
          ))}

          {groups.includes("Admins") &&
            !formParams.find((param) => param.name === "owner") && (
              <Grid item xs={12}>
                <InputLabel>{t("owner")}</InputLabel>
                <Controller
                  name="owner"
                  as={TextField}
                  defaultValue={form.getValues("owner")}
                  control={form.control}
                  rules={{ required: true }}
                />
              </Grid>
            )}

          <Grid item xs={12}>
            <Button
              startIcon={<SaveIcon />}
              variant="contained"
              color="primary"
              type="submit"
              size="large"
              disabled={loading}
            >
              {t(action)}
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  );
}
